/* tslint:disable */
/**
 * Auto generated version file, do not modify it!
 */
const version = '0.10.30';
export { version };
//# sourceMappingURL=version.js.map